import { render, staticRenderFns } from "./Equipamento.vue?vue&type=template&id=4d421234&"
import script from "./Equipamento.vue?vue&type=script&lang=js&"
export * from "./Equipamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports